<div class="cta-banner">
  <app-container>
    <div class="cta-banner__card">

      <!-- Temporalmente comentamos la imagen hasta tenerla disponible -->
        <div class="cta-banner__image-container">
        <img
          src="https://www.unipay.cl/api/descargaArchivo/web-solicita02.png"
          alt="Persona usando Unipay"
          class="cta-banner__image"
        />
      </div>

      <div class="cta-banner__content">
        <div class="cta-banner__text">
          <h3 class="cta-banner__title">Solicita hoy tu Unipay</h3>
          <p class="cta-banner__subtitle">Y disfruta nuestros descuentos exclusivos en Unimarc, Alvi, Super 10, Unimarc.cl y App Unimarc</p>
        </div>
        <div class="cta-banner__button-container">
          <a href="https://www.unipay.cl/autoatencion-ptoventa/validar-identidad?utm_source=Digital&utm_medium=Pagina_Unipay&utm_campaign=banner" target="_blank" class="cta-banner__button">
            Solicitar Unipay
          </a>
        </div>
      </div>
    </div>
  </app-container>
</div>
